// extracted by mini-css-extract-plugin
export var dropdownContainer = "_sa-0";
export var leftAlign = "_sa-4";
export var listItem = "_sa-2";
export var listItemWrapper = "_sa-1";
export var operationText = "_sa-3";